import { retry } from '@reduxjs/toolkit/query/react';
import { ClientError, GraphQLClient, Variables } from 'graphql-request';
import auth from '@udacity/ureact-hoth';

export type GraphqlQuery = {
  document: string;
  variables: Variables | void;
};

function isGraphqlMutation(document: string): boolean {
  return /^\s*mutation\b/i.test(document);
}

export function getGqlBaseQuery(baseUrl: string) {
  const client = new GraphQLClient(baseUrl);

  return async ({ document, variables }: GraphqlQuery) => {
    const jwt = auth.getJWT();
    client.setHeader('Authorization', `Bearer ${jwt}`);
    try {
      const result = await client.request(document, variables || undefined);
      return { data: result };
    } catch (error) {
      if (error instanceof ClientError) {
        const errorMessage = ((error.message as string) || '').split(': {')[0];
        const returnedError = {
          status: error.response.status,
          data: errorMessage,
          metadata: {
            response: error.response.data,
            errors: error.response.errors,
          },
        };
        // GraphQL errors (HTTP 200) are not transient. Mutations must not
        // retry on 5xx/timeout either — the backend may already have applied
        // CreateMentor / JoinQueue / ClaimMeetings.
        if (error.response.status === 200 || isGraphqlMutation(document)) {
          return retry.fail(returnedError);
        }
        return { error: returnedError };
      }
      const networkError = { status: 500, data: error };
      if (isGraphqlMutation(document)) {
        return retry.fail(networkError);
      }
      return { error: networkError };
    }
  };
}
